import { useMemo } from 'react';
import { useAppSelector } from '../../../redux/hooks';
import { dashboardSelectUniqueSchemas } from '../../../redux/selectors/dashboardInstance';
import useDashboardSelector from '../../../redux/selectorHooks/useDashboardSelector';
import { MaybeNil } from '../../../utils/interfaces';

// Returns Dashboard schemaId by priority:
// 1. From customization
// 2. From analyses if all of them has the same schemaId
const useDashboardSchemaId = () => {
  const dashboard = useDashboardSelector('dashboard');
  // do not assert that dashboard is not null. It is used outside Dashboard page (DictionaryTab)
  const uniqueSchemas = useAppSelector(dashboardSelectUniqueSchemas);

  return useMemo((): MaybeNil<string> => {
    if (dashboard?.filter?.schema?.id) {
      return dashboard.filter.schema.id;
    }

    return uniqueSchemas.length === 1 ? uniqueSchemas[0] : null;
  }, [dashboard, uniqueSchemas]);
};

export default useDashboardSchemaId;
